module.exports = __webpack_public_path__ + "img/dsWhatsapp.3b74eee0.svg";